import uncachedHash, { type NotUndefined } from 'object-hash';

import type { ComputedContentSource } from '../types';
import type { ComputedContentSourceDependency } from './types';

const objectHashCache = new WeakMap<any, string>();

/**
 * Hash an object, while using a cache to avoid rehashing the same object.
 */
export function hash(object: NotUndefined): string {
    const isCacheable = typeof object === 'object' && object !== null && object !== undefined;
    const existing = isCacheable ? objectHashCache.get(object) : undefined;
    if (existing) {
        return existing;
    }

    const result = uncachedHash(object);
    if (isCacheable) {
        objectHashCache.set(object, result);
    }
    return result;
}

/**
 * Hash a computed content source.
 */
export function hashComputedContentSource(source: ComputedContentSource): string {
    return hash(source);
}

/**
 * Hash a dependency reference.
 */
export function hashDependencyRef(
    dependency: ComputedContentSourceDependency<ComputedContentSource>
): string {
    return hash(dependency.ref);
}

/**
 * Get a prefixed ID for a computed content.
 * The idea is to make it easier to recognize them to potentially clean them up later.
 * These content are not meant to be accessed directly, and are cache.
 */
export function getComputeContentId(id: string) {
    return `computed_${id}`;
}
